/**
 * Created by jv on 30/05/2018.
 */
const ATLAS_KEY = "chicken-game-atlas";

export default {
  DEBUG: false,

  ATLAS_KEY,

  DROP_MODES: {
    ANYWHERE: "anywhere",
    ZONE_ONLY: "zone-only"
  },

  CHICK_HATCH_POSITIONS: [ "left", "bottom", "right" ],
  CHICK_RUN_DIRECTIONS: [ "n", "ne", "e", "se", "s", "sw", "w", "nw" ]
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/config/constants.js